import React from 'react'
import PropTypes from 'prop-types'
import { database } from 'helpers/firebase'
import { withRouter } from 'react-router-dom'

import { withStyles } from 'material-ui/styles'
import Drawer from 'material-ui/Drawer'
import Divider from 'material-ui/Divider'
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List'
import Typography from 'material-ui/Typography'
import Hidden from 'material-ui/Hidden'

import { routes } from 'constants/routes'
import { APP_TITLE } from 'constants/customization'
import styles from 'styles/components/SideNav'

class SideNav extends React.Component {
  navigateTo(link) {
    return () => {
      // Close the drawer on click
      this.props.toggle(false)

      // Only try to navigate if the target is not the current page
      if (this.props.location.pathname !== link.path) {
        this.props.history.push(link.path)
      }
    }
  }

  handleOpenPatchNotes = () => {
    database.ref(`users/${this.props.user.uid}`).update({
      patch: ''
    })
  }

  render() {
    const { classes, location } = this.props

    const drawerContent = (
      <div>
        <div className={classes.drawerHeader}>
          <div className={classes.drawerHeaderWrapper}>
            <Typography variant="headline" className={classes.drawerTitle}>
              {APP_TITLE}
            </Typography>
            <Typography variant="caption">
              <a
                onClick={this.handleOpenPatchNotes}
                className={classes.versionLink}
              >
                Version {process.env.REACT_APP_VERSION}
              </a>
            </Typography>
          </div>
        </div>
        <Divider />
        <List>
          {routes
            .map(link => ({ ...link, active: link.path === location.pathname }))
            .map(
              link =>
                !link.redirect && (
                  <ListItem
                    className={link.active ? classes.activeListItem : undefined}
                    key={link.path}
                    onClick={this.navigateTo(link)}
                    button={!link.active}
                  >
                    <ListItemIcon
                      className={
                        link.active ? classes.activeListIcon : undefined
                      }
                    >
                      {link.icon}
                    </ListItemIcon>
                    <ListItemText
                      classes={{
                        primary: link.active
                          ? classes.activeListText
                          : classes.listText
                      }}
                      primary={link.title}
                    />
                  </ListItem>
                )
            )}
        </List>
      </div>
    )

    return (
      <div>
        <Hidden mdUp>
          <Drawer
            variant="temporary"
            anchor="left"
            open={this.props.open}
            classes={{ paper: classes.drawerPaper }}
            onClose={this.props.toggle}
            ModalProps={{ keepMounted: true }}
          >
            {drawerContent}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            variant="permanent"
            open
            classes={{ paper: classes.drawerPaper }}
          >
            {drawerContent}
          </Drawer>
        </Hidden>
      </div>
    )
  }
}

SideNav.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

export default withStyles(styles)(withRouter(SideNav))



// WEBPACK FOOTER //
// ./src/components/SideNav.jsx